import moment from 'moment';
import _ from 'lodash';
import { store } from '@/store';
import { comma } from 'postcss/lib/list';

/**
 * 保單
 */
const state = () => ({
    provs: [], // 147駕傷資料
    isAllowEC: true, // 是否允許網投
    calculatedAt: null, // 上一次登入後計算保費的時間
    comboId: null, // 組合保單 id
    customization: false, // 是否為自選商品
    entry: null, // 投保進入點 customization:自選保單 | combo:組合商品 | helper: 小幫手 | lookup: 投保後查詢
    insuresAndCoversLoaded: false, // 保險內容選項是否已下載
    insuresNameLoadedCar: false, // 汽車 保險顯示名稱是否已下載
    insuresNameLoadedMotor: false, // 機車 保險顯示名稱是否已下載
    name: null, // 保單名稱 e.g 自選保單1 or 組合保單名稱
    type: 'owner', // 投保類型 owner:要被保同人 | agent: 要被保不同人 | corporation: 企業
    price: null, // 定價（回傳的各險種加總）
    salePrice: null, // 網路售價 (PremiumChoice + PremiumCompel)
    comboPrice: null, //商品組合、幫手組合價格
    depreciate: { text: '15%', value: 'P' },
    confirm: {
        personal: false, // 個人資料告知事項
        insurance: false,
    },
    completeMessage: null, //投保完成頁文案(待審件才會有)
    activityCode: '', // 活動代碼
    activityCodeLock: false, // 讓活動代碼成為不可修改狀態(從網址取得時)
    corp: '', // iChannels 代碼
    payWay: null, // 已選擇的繳費方式(待審件為Null)
    payWays: [], // api-17 回傳
    paid: false, // 已付款完成
    alertMessage: [], // api-2,17,39 回傳之 Policy.AlertMessage
    renewMessage: [], // api-2,17,39 回傳之 Policy.renewMessage
    paymentMaintainInfo: null, // CMS設定的繳費頁文案
    isRequireProposal: false, // 是否需顯示要保書寄送選項
    isEC: true, // 是否為網投
    isRenew: false, // 是否為續保，續保登入成功後為 true
    // 所有保單種類
    allInsurances: [
        '01',
        '02',
        '05',
        '07',
        '09',
        '10',
        '11',
        '12',
        '15',
        '17',
        '19',
        '21',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '34',
        '47',
        '55',
        '56',
        '62',
        '63',
        '64',
        '109',
        '110',
        '111',
        '113',
        '114',
        '115',
        '117',
        '147',
        '161',
        '164',
        '165',
        '166',
        '198',
        '237',
        '238',
        '301',
        '201',
        '205',
        '209',
        '176',
        '177',
        '211',
        '231',
        '232',
        '178'
    ],
    // 任意險
    choiceInsures: [
        '01',
        '02',
        '05',
        '07',
        '09',
        '10',
        '11',
        '12',
        '15',
        '17',
        '19',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '34',
        '47',
        '55',
        '56',
        '62',
        '63',
        '64',
        '109',
        '110',
        '111',
        '113',
        '114',
        '115',
        '117',
        '147',
        '161',
        '164',
        '165',
        '166',
        '198',
        '237',
        '238',
        '301',
        '201',
        '205',
        '209',
        '176',
        '177',
        '211',
        '231',
        '232',
        '178'
    ],
    // 強制險
    compulsoryInsures: ['21', '47', '147'],
    // 車體損失險
    carDamageInsures: ['01', '05', '09', '110', '111', '198', '201', '205', '209'],
    liabilityInsures: ['31', '32', '231', '232', '113', '114', '115'],
    burglaryInsures: ['11', '211'],
    otherInsures: ['117', '15', '237', '238'],
    //需要調整折舊率的險種(移除了 198，198 固定為['P'])
    insuresIncludeDepreciate: ['01', '05', '09', '11', '201', '205', '209', '211'],
    cardHolders: [],
    checked: false, // 是否已在 server 端驗證過(透過 api-39 CheckBeforeSave)
    Insures: [], // 從街口/全支付付款回來取投保險種()
    defaultIns: [], // 預勾險種 InitPolicy後端會取回policy.DefaultIns
    midUrl:null, //MID驗證網址
    requestId:null, //MID verifyNo
});

const actions = {};

const getters = {
    /**
     * 是否有保強制險
     * @returns {Boolean}
     */
    hasCompel: () => {
        return store.state.ins21.selected;
    },
    /**
     * 是否有保任意險
     * @param state
     * @returns {Boolean}
     */
    hasChoice: (state) => {
        let result = false;
        _.forEach(state.choiceInsures, (v) => {
            if (store.state['ins' + v].selected) {
                result = true;
                return true;
            }
        });

        return result;
    },
    /**
     * 是否有保車體損失險
     * @param state
     * @returns {Boolean}
     */
    hasCarDamage: (state) => {
        let result = false;
        _.forEach(state.carDamageInsures, (v) => {
            if (store.state['ins' + v].selected) {
                result = true;
                return true;
            }
        });

        return result;
    },
    /**
     * 是否有保強制險21 47 147
     * @param state
     * @returns {Boolean}
     */
    hasCompulsory: (state) => {
        let result = false;
        _.forEach(state.compulsoryInsures, (v) => {
            if (store.state['ins' + v].selected) {
                result = true;
                return true;
            }
        });

        return result;
    },
    /**
     * 是否有保第三人31 32 231 232 113 114 115
     * @param state
     * @returns {Boolean}
     */
    hasLiability: (state) => {
        let result = false;
        _.forEach(state.liabilityInsures, (v) => {
            if (store.state['ins' + v].selected) {
                result = true;
                return true;
            }
        });

        return result;
    },
    /**
     * 是否有保竊盜 11 211
     * @param state
     * @returns {Boolean}
     */
    hasBurglary: (state) => {
        let result = false;
        _.forEach(state.burglaryInsures, (v) => {
            if (store.state['ins' + v].selected) {
                result = true;
                return true;
            }
        });

        return result;
    },
    /**
     * 是否有保其他 117 15 237 238
     * @param state
     * @returns {Boolean}
     */
    hasOther: (state) => {
        let result = false;
        _.forEach(state.otherInsures, (v) => {
            if (store.state['ins' + v].selected) {
                result = true;
                return true;
            }
        });

        return result;
    },
    /**
     * 選擇購買的險種
     * @param {*} state
     * @returns {Array}
     */
    selectedInsurances: (state) => {
        return _.chain(state.allInsurances)
            .map((v) => {
                return store.state['ins' + v].selected
                    ? store.state['ins' + v].uploadForm
                    : null;
            })
            .without(null)
            .value();
    },
    /**
     * 判斷是否顯示車輛使用人姓名
     * @param {*} state
     * @param {*} getters
     * @returns
     */
    showUserNames: (state, getters) => {
        return getters.hasCarDamage && !store.state.ins10.selected;
    },
    /**
     * 判斷是否有續保資料
     * @param {*} state
     * @returns
     */
    useRenewPolicy: (state) => {
        return (
            state.isRenew &&
            store.state.renewPolicy.Policy302s &&
            store.state.renewPolicy.Policy302s.length > 0
        );
    },
};

const mutations = {
    /**
     * 是否可以網路投保
     */
    allowEC(state, payload) {
        state.isAllowEC = payload;
    },
    /**
     * 清除資料
     * @param {*} state
     */
    clear(state) {
        state.provs = {},
        state.isAllowEC = true;
        state.calculatedAt = null;
        state.comboId = null;
        state.customization = false;
        state.entry = null;
        state.name = null;
        state.type = 'owner';
        state.price = null;
        state.salePrice = null;
        state.comboPrice = null;
        state.depreciate = { text: '15%', value: 'P' };
        state.completeMessage = null;
        state.payWay = null;
        state.payWays = [];
        state.paid = false;
        state.alertMessage = [];
        state.renewMessage = [];
        state.isRequireProposal = false;
        state.isEC = true;
        state.isRenew = false;
        state.checked = false;
        // state.activityCode = null;
        state.cardHolders = [];
        state.Insures = [];
        state.defaultIns = [];
        state.paymentMaintainInfo = null;
    },
    /**
     * 是否已閱讀個人事項等相關聲明
     * @param {*} state
     * @param {*} payload
     */
    confirm(state, payload) {
        state.confirm[payload.key] = payload.value;
    },
    /**
     * 要保書寄送選項
     * @param {*} state
     * @param {*} payload
     */
    requireProposal(state, payload) {
        state.isRequireProposal = payload;
    },
    /**
     * 設定活動代碼
     * @param {*} state
     * @param {*} payload
     */
    setActivityCode(state, payload) {
        state.activityCode = payload;
    },
    /**
     * 設定活動代碼
     * @param {*} state
     * @param {*} payload
     */
    setProvs(state, payload) {
        state.provs = payload;
    },
    /**
     * 設定活動代碼並鎖定
     * @param {*} state
     * @param {*} payload
     */
    setActivityCodeLock(state, payload) {
        if (payload) {
            state.activityCode = payload;
            state.activityCodeLock = true;
        }
    },
    /**
     * 後端回傳預勾險種（讓自選頁使用）
     */
    setDefaultIns(state, payload) {
        state.defaultIns = payload;
    },
    /**
     * 保單相關訊息（讓付款頁使用）
     */
    setCardHolders(state, payload) {
        state.cardHolders = payload;
    },
    /**
     * iChannels 代碼
     * @param {*} state
     * @param {*} payload
     */
    setCorp(state, payload) {
        state.corp = payload;
    },
    /**
     * 投保類型 owner:要被保同人 | agent: 要被保不同人 | corporation: 企業
     * @param {*} state
     * @param {*} payload
     */
    setType(state, payload) {
        state.type = payload;
    },
    /**
     * 投保完成頁文案(待審件才會有)
     */
    setCompleteMessage(state, payload) {
        state.completeMessage = payload;
    },
    /**
     * 已選擇的繳費方式(待審件為Null)
     */
    setPayWay(state, payload) {
        state.payWay = payload;
    },
    /**
     * 已付款完成
     * @param {*} state
     * @param {*} payload
     */
    setPaid(state, payload) {
        state.paid = payload;
    },
    /**
     * 折舊率
     * @param {*} state
     * @param {*} payload
     */
    setDepreciate(state, payload) {
        state.depreciate = payload;
    },
    /**
     * 付款方式 api-17 回傳
     * @param {*} state
     * @param {*} payload
     */
    setPayWays(state, payload) {
        state.payWays = payload;
    },
    /**
     * 付款方式 api-17 回傳
     * @param {*} state
     * @param {*} payload
     */
    setPayWaysByAPI(state, payload) {
        state.payWays = [];
        _.forEach(payload, (value, key) => {
            state.payWays.push(key);
        });
    },
    /**
     * 定價（回傳的各險種加總）
     * @param {*} state
     * @param {*} payload
     */
    setPrice(state, payload) {
        state.price = payload;
    },
    /**
     * 網路售價 (PremiumChoice + PremiumCompel)
     */
    setSalePrice(state, payload) {
        state.salePrice = payload;
    },
    /**
     * 上一次登入後計算保費的時間
     * @param {*} state
     */
    setCalculatedAt(state) {
        if(!!state.salePrice){
            state.calculatedAt = moment().format();
        }
    },
    /**
     * 組合保單
     * @param {*} state
     * @param {*} payload
     */
    setCombo(state, payload) {
        state.comboId = payload.comboId;
        state.name = payload.name;
        state.entry = 'combo';
        state.comboPrice = payload.comboPrice;
    },
    /**
     * 投保進入點 customization:自選保單 | combo:組合商品 | helper: 小幫手 | lookup: 投保後查詢
     * @param {*} state
     */
    setCustomization(state) {
        state.comboId = 'customization';
        state.name = '自選商品';
        state.entry = 'customization';
    },
    /**
     * 推薦商品組合的標題
     * @param {*} state
     * @param {*} payload
     */
    setHelper(state, payload) {
        const level = {
            精選推薦: 'helper_low',
            幫手推薦: 'helper_mid',
            升級推薦: 'helper_high',
        };

        state.comboId = level[payload];
        state.name = '投保小幫手';
        state.entry = 'helper';
        state.comboPrice = payload.price;
    },
    /**
     * 查詢保單
     * @param {*} state
     */
    setLookup(state) {
        state.entry = 'lookup';
    },
    /**
     * 分享回復
     * @param {*} state
     */
    setShared(state) {
        state.entry = 'shared';
    },
    /***
     * 是否為網投
     */
    setIsEC(state, payload) {
        state.isEC = payload;
    },
    /**
     * 保險內容選項是否已下載
     * @param {*} state
     * @param {*} payload
     */
    setInsuresAndCoversLoaded(state, payload) {
        state.insuresAndCoversLoaded = payload;
    },
    /**
     * 汽車 保險顯示名稱是否已下載
     * @param {*} state
     * @param {*} payload
     */
    setInsuresNameLoadedCar(state, payload) {
        state.insuresNameLoadedCar = payload;
    },
    /**
     * 機車 保險顯示名稱是否已下載
     * @param {*} state
     * @param {*} payload
     */
    setInsuresNameLoadedMotor(state, payload) {
        state.insuresNameLoadedMotor = payload;
    },
    /**
     * 提醒訊息：api-2,17,39 回傳之 Policy.AlertMessage
     * @param {*} state
     * @param {*} payload
     */
    setAlertMessage(state, payload) {
        state.alertMessage = payload;
    },
    /**
     * 續保提醒訊息：api-2,17,39 回傳之 Policy.renewMessage
     * @param {*} state
     * @param {*} payload
     */
    setRenewMessage(state, payload) {
        state.renewMessage = payload;
    },
    /**
     * 費頁上方需顯示的訊息
     * @param {*} state
     * @param {*} payload
     */
    setPaymentMaintainInfo(state, payload) {
        state.paymentMaintainInfo = payload;
    },
    /**
     * 是否為續保
     * @param {*} state
     * @param {*} payload
     */
    setIsRenew(state, payload) {
        state.isRenew = payload;
    },
    setInsures(state, payload) {
        state.Insures = payload;
    },
    setMid(state, payload) {
        state.midUrl = payload.url;
        state.midRequestId = payload.requestId;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
